import { Link } from 'react-router-dom';

const news = [
  {
    id: 1,
    date: '2025.04.09',
    tag: '重要',
    tagColor: 'bg-red-700',
    title: '【重要】登記変更手続き中のお知らせ',
    body: '現在、合同会社ＡＺは登記変更手続きを進めております。手続き完了まで一部情報が旧登記内容と異なる場合がございますが、業務運営には支障ございません。ご不明な点はお気軽にお問い合わせください。',
  },
  {
    id: 2,
    date: '2025.03.15',
    tag: 'お知らせ',
    tagColor: 'bg-[#c9a84c]',
    title: 'コーポレートサイトを開設いたしました',
    body: '合同会社ＡＺの公式ウェブサイトを開設いたしました。今後ともよろしくお願いいたします。',
  },
];

export default function NewsSection() {
  return (
    <section className="bg-[#f8f5ef] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase block mb-2">News</span>
            <h2 className="font-serif-jp text-[#0f1628] text-2xl md:text-3xl tracking-wider font-medium">お知らせ</h2>
          </div>
          <div className="w-16 h-px bg-[#c9a84c]"></div>
        </div>

        {/* News List */}
        <div className="flex flex-col gap-0 border-t border-[#0f1628]/10">
          {news.map((item) => (
            <div
              key={item.id}
              className="flex flex-col md:flex-row md:items-start gap-3 md:gap-8 py-6 border-b border-[#0f1628]/10"
            >
              <div className="flex items-center gap-4 md:min-w-[200px]">
                <span className="text-[#0f1628]/40 text-xs tracking-widest font-sans whitespace-nowrap">{item.date}</span>
                <span className={`${item.tagColor} text-white text-xs px-3 py-0.5 tracking-wider font-sans whitespace-nowrap`}>
                  {item.tag}
                </span>
              </div>
              <div className="flex-1">
                <p className="font-serif-jp text-[#0f1628] text-sm md:text-base tracking-wide mb-2">
                  {item.title}
                </p>
                <p className="text-[#0f1628]/50 text-xs leading-relaxed font-sans">
                  {item.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
